<div #scrollContainer class="items-container" style="width:100%" (window:resize)="onResize($event)">

  <div class="" style="width:100%" #ItemsContainer>
    <div class="meal_all_items_container" #rowLayout cdkDropListGroup>

      <div class="fitness-items-row" *ngFor="let itemsRow of getItemsTable(); let i = index;" cdkDropList
        cdkDropListOrientation="horizontal" [cdkDropListData]="itemsRow"
        (cdkDropListDropped)="reorderDroppedItem($event)">
        <ng-container *ngFor="let item of itemsRow;  let j = index;">

          <div *ngIf="item!=null" class="cdk-fitness-item" cdkDrag [cdkDragStartDelay]="cdkDelay()">

            <div class="drag-placeholder" *cdkDragPlaceholder></div>

            <div class="container" [hidden]="PlanView">
              <app-fitness-item-presentation [PatientID]="PatientID" [PatientName]="PatientName" [fitnessBlock]="FitnessBlock"
                [IsPreferredUnitImperial]="IsPreferredUnitImperial" [BlockOrder]="FitnessBlock.order"
                [BlockType]="BlockType" [CircuitRest]="CircuitRest" [IsLastItem]="getCumIndex(i,j)==PlanItems.length-1"
                [FitnessItem]="item" [DeleteCallBack]="DeleteItem.bind(this)" [SaveCallBack]="SaveItem.bind(this)">
              </app-fitness-item-presentation>
            </div>

          </div>

        </ng-container>



      </div>
      <div class="fitness-items-row">

        <div style="display: contents;">
          <div class="quick_add">
            <div [hidden]="PlanView" (click)="SelectItems()">
              <a class="AddItemLocation" id="MealItemImage" src='assets/images/AddItemImage.png'>Add Exercice</a>
            </div>
          </div>

          <div class="quick_add">
            <div [hidden]="PlanView" (click)="CreateAndAddQuickItem()">
              <a class="AddItemLocation">Quick Add</a>
            </div>
          </div>


        </div>




      </div>
    </div>

  </div>

</div>